import { showLoginSheet, showToast } from './member-actions.js';

let Reminders = {
  reminderSheet: null,
  reminderOffcanvas: null,
  reminderCalendar: null,
  reminderDates: [],
  reminderIds: {},
  allDateReminders: [],
  getDateString: function(date) {
    if (date == 'all') {
      return 'All Dates'
    } else {
      return new Date(date).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric', timeZone: 'UTC' });
    }
  },
  overlayOn: function(container) {
    $('.loading-spinner', container).show();
    $('.display-item', container).hide();
  },
  overlayOff: function(container) {
    $('.display-item', container).show();
    $('.loading-spinner', container).hide();
  },
  showSheetError: function(sheet, message) {
    if (message) {
      $('.error-message', sheet).html(message);
    }
    $('.error-body', sheet).show();
    $('.add-body', sheet).hide();
    $('.success-body', sheet).hide();
  },
  clearSheetError: function(sheet) {
    $(".error-body", sheet).hide();
  },
  createReminder: function(oid, model, date) {
    var thisObj = this;
    if(!Object.keys(thisObj.reminderIds).includes(date)) {
      let data = {
        'date': date,
        'oid': oid,
        'model': model
      };
      let button;
      if (date == 'all') {
        button = $('a[data-date="all"]', thisObj.reminderSheet);
      } else {
        button = $(`.reminder-btn[data-oid="${oid}"][data-model="${model}"][data-date="${date}"]`);
      }
      fetch('/api/reminders/', {
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
          'X-CSRFToken': Cookies.get('csrftoken'),
          'Content-Type': 'application/json'
        },
        credentials: 'same-origin'
      })
      .then(response => response.json())
      .then(data => {
        if (data.result == "success") {
          let dateString = (data.all_dates) ? 'all' : date;
          let tdDate = new tempusDominus.DateTime(date+'T00:00:00');
          if(dateString == 'all') {
            thisObj.reminderIds = {}
          }
          thisObj.reminderIds[dateString] = data.id;
          thisObj.reminderDates.push(tdDate);
          thisObj.toggleReminder('remind', button, data.id);
          if (data.first_time) {
            $('#messageModal .modal-title').html('🎉 Hooray! 🎉');
            $("#messageModal .modal-body").html(`
              <div class="alert alert-success text-center">You just created your first reminder! High five! 🖐️</div>
              <div class="my-4">
                <p class="fs-4"><strong>We’ll email you about this event the day before it happens.</strong><br>You’ll also get a list of your reminders for the week on Monday mornings, or a different day if you prefer.</p>
              </div>
              <p class="fs-4 text-muted pt-3 border-top"><a href="/account/reminders"><strong>View all your reminders and manage your reminder settings here</strong></a>!</p>
            `);
            $('#messageModal').modal('show');
          }
        }
      })
      .catch(error => {
        console.log(error);
      });
    } else {
      // date already in list
    }
  },
  removeReminder: function(reminderId, button, suppressToast) {
    var thisObj = this;
    if (reminderId) {
      $(button).children('.reminder-btn:first').addClass('bell-ring');
      fetch(`/api/reminders/${reminderId}/`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': Cookies.get('csrftoken')
        },
        credentials: 'same-origin'
      }).then(response => {
        if (!response.ok) {
          throw new Error('There was a problem getting your reminders.');
        } else {
          thisObj.toggleReminder('remove', button, reminderId, suppressToast);
        }
      }).catch(error => {
        console.log(error.message);
      });
    }
  },
  toggleReminder: function(action, el, id, suppressToast, dontCount) {
    var thisObj = this;
    var oid = ($(el).data('oid')) ? $(el).data('oid') : $('input[name=oid]', thisObj.reminderSheet).val();
    var model = ($(el).data('model')) ? $(el).data('model') : $('input[name=model]', thisObj.reminderSheet).val();
    var date = ($(el).data('date')) ? $(el).data('date') : Object.keys(thisObj.reminderIds).find(key => thisObj.reminderIds[key] == id);
    var objectName = ($(el).data('objectName')) ? $(el).data('objectName') : $('input[name=object_name]', thisObj.reminderSheet).val();

    var forObject = (objectName) ? objectName : '';
    if (date) {
      forObject += ': ' + thisObj.getDateString(date);
    }
    if (action == 'remind') {
      thisObj.reminderIds[date] = id;
      if(!suppressToast) {
        showToast('<strong>Reminder set!</strong><br>' + forObject);
      }
      if (date == 'all') {
        $(el).data('itemId', id);
        $('#calendarAll .reminder-set-message', thisObj.reminderSheet).show();
        $('#calendarAll .no-reminder-message', thisObj.reminderSheet).hide();
        $('.upcoming-event-times .all-dates-message').show();
      } else {
        $('.reminder-btn-all', thisObj.reminderSheet).data('itemId', '');
        $('#calendarAll .reminder-set-message', thisObj.reminderSheet).hide();
        $('#calendarAll .no-reminder-message', thisObj.reminderSheet).show();
        $('.upcoming-event-times .all-dates-message').hide();
      }
      if (($(thisObj.reminderSheet).hasClass('show') || $(thisObj.reminderSheet).hasClass('showing')) && !$(thisObj.reminderSheet).hasClass('hiding') ) {
        thisObj.createRemoveReminderRow(date, id);
      }
    } else if (action == 'remove') {
      delete thisObj.reminderIds[date];
      $(`.remove-reminder-btn[data-date="${date}"]`).parents('.remove-reminder-row').hide();
      if (!suppressToast) {
        showToast("<strong>Reminder removed</strong><br>" + forObject);
      }
      if (date == 'all') {
        $(el).data('itemId', '');
        $('.upcoming-event-times .all-dates-message').hide();
        $('#calendarAll .reminder-set-message', thisObj.reminderSheet).hide();
        $('#calendarAll .no-reminder-message', thisObj.reminderSheet).show();
      }
    }
    if (thisObj.reminderCalendar && date != 'all') {
      var parsedDate = thisObj.reminderCalendar.dates.parseInput(date);
      if (action == 'remove') {
        var pickedDates = thisObj.reminderCalendar.dates.picked.map(function(d) { return d.toLocaleDateString('en-US') });
        var dateIndex = pickedDates.indexOf(parsedDate.toLocaleDateString('en-US', { timeZone: 'UTC' }));
        if (dateIndex > -1) {
          thisObj.reminderCalendar.dates.setFromInput(null, dateIndex);
        }
      }
      thisObj.updateReminderCardDate(oid, thisObj.reminderCalendar.dates._dates, []);
    } else if (date == 'all') {
      thisObj.updateReminderCardDate(oid, ['all'], []);
    }

    var detailReminderButton = $(`.event-detail-reminder .reminder-btn[data-oid="${oid}"][data-model="${model}"]`);
    if(!dontCount) {
      var reminderCount = (Object.keys(thisObj.reminderIds).includes('all')) ? 1 : Object.values(thisObj.reminderIds).length;
      if(reminderCount > 0) {
        if(reminderCount == 1) {
          $('.reminder-plural').hide();
          $('.reminder-btn .reminder-count-message .reminder-count').html('');
          $('.reminder-count-message .reminder-count', thisObj.reminderSheet).html(reminderCount);
          $('.item-tools-label .reminder-count', detailReminderButton).html('');
        } else {
          $('.reminder-plural').html('s').show();
          $('.reminder-count-message .reminder-count').html(reminderCount);
          $('.item-tools-label .reminder-count', detailReminderButton).html(reminderCount);
        }
        if (detailReminderButton) {
          $('.event-detail-reminder .reminder-set-message').show();
          $('.event-detail-reminder .no-reminder-message').hide();
          $(detailReminderButton).addClass('btn-primary').removeClass('btn-dark text-primary');
        }
        $('.reminder-count-message', thisObj.reminderSheet).show();
        $(".reminder-body .default-message").hide();
      } else {
        if (detailReminderButton) {
          $('.item-tools-label .reminder-count', detailReminderButton).html('');
          $('.event-detail-reminder .reminder-set-message').hide();
          $('.event-detail-reminder .no-reminder-message').show();
          $(detailReminderButton).removeClass('btn-primary').addClass('btn-dark text-primary');
        }
        $('.reminder-count-message', thisObj.reminderSheet).hide();
        $(".reminder-body .default-message").show();
      }
    }
    function toggleButtonState(button, reminderCount) {
      $(button).children('.reminder-btn-bell:first').addClass('bell-ring');
      if (action == 'remind') {
        $(button).addClass('reminded');
        if($(button).hasClass('btn')) {
          $(button).addClass('btn-primary').removeClass('btn-light');
        }
        $(button).find('.reminder-btn-bell').removeClass('fa-swap-opacity fa-bell').addClass('fa-bell-on');
        $('.reminder-set-message', button).show();
        $('.no-reminder-message', button).hide();
        $(button).data('itemId', id);
      } else if (action == 'remove' && !reminderCount) {
        $(button).removeClass('reminded');
        if($(button).hasClass('btn')) {
          $(button).addClass('btn-light').removeClass('btn-primary');
        }
        $(button).find('.reminder-btn-bell').addClass('fa-swap-opacity fa-bell').removeClass('fa-bell-on');
        $('.reminder-set-message', button).hide();
        $('.no-reminder-message', button).show();
        $(button).data('itemId', '');
      }
      setTimeout(() => {
        $(button).children('.reminder-btn-bell:first').removeClass('bell-ring');
      }, 1500);
    }
    let buttons;
    if(date == "all") {
      buttons = $(`.reminder-btn[data-oid="${oid}"][data-model="${model}"]`);
    } else {
      buttons = $(`.reminder-btn[data-oid="${oid}"][data-model="${model}"][data-date="${date}"]`);
    }
    buttons.each(function() { toggleButtonState(this) });
    let noDateButton = $(`.reminder-btn[data-oid="${oid}"][data-model="${model}"]:not([data-date])`);
    var reminderCount = Object.values(thisObj.reminderIds).length;
    noDateButton.each(function() { toggleButtonState(this, reminderCount); });
    if(date == 'all') {

    }
  },
  calendarOnChange: function(e) {
    const model = $('input[name=model]', Reminders.reminderSheet).val();
    const oid = $('input[name=oid]', Reminders.reminderSheet).val();

    if (!e.detail.isClear) {
      if (e.detail.oldDate) {
        var date = e.detail.oldDate.toISOString().split('T')[0];
        Reminders.removeReminder(Reminders.reminderIds[date], this);
      } else if (e.detail.date) {
        var date = e.detail.date.toISOString().split('T')[0];
        Reminders.createReminder(oid, model, date);
      }
    }
  },
  toggleSheetAfterClear: function(singleDate, el) {
    var thisObj = this;
    if (singleDate) {
      this.overlayOn();
      this.reminderOffcanvas.hide();
    } else {
      $('.add-body', this.reminderSheet).show();
      $('.clear-body', this.reminderSheet).hide();
      $('.add-title', this.reminderSheet).show();
      $('.clear-title', this.reminderSheet).hide();
      $('.reminder-count-message').show();
      if(!this.reminderCalendar) {
        var oid = $(el).data('oid');
        var model = $(el).data('model');
        var date = $(el).data('date');
        var objectName;
        var dateString;
        var dateCount;
        thisObj.populateReminderSheet(oid, model, objectName, dateString, date, dateCount);
      }
    }
  },
  clearAllReminders: function(e) {
    var reminders = Object.values(Reminders.reminderIds);
    for (let i = 0; i < reminders.length; i++) {
      Reminders.removeReminder(reminders[i], e, true);
    }
    showToast('Reminders cleared' + ' for ' + $('input[name=object_name]', Reminders.reminderSheet).val()) + '!';
    $('.reminder-btn-all', Reminders.reminderSheet).data('itemId', '');
    var dateCount = ($(e).data('dateCount')) ? $(e).data('dateCount') : $('input[name=date_count]', Reminders.reminderSheet).val();
    var singleDate = (singleDate) ? singleDate : (dateCount == 1) ? true : false;
    Reminders.reminderOffcanvas.show();
    Reminders.toggleSheetAfterClear(singleDate, e);
    return false;
  },
  confirmReminderClear: function(el, callback, singleDate, allDateToggle) {
    var thisObj = this;
    var oid = ($(el).data('oid')) ? $(el).data('oid') : $('input[name=oid]', thisObj.reminderSheet).val();
    var model = ($(el).data('model')) ? $(el).data('model') : $('input[name=model]', thisObj.reminderSheet).val();
    var date = ($(el).data('date')) ? $(el).data('date') : $('input[name=date]', thisObj.reminderSheet).val();
    if(allDateToggle) {
      var dateString = 'all dates on this event, and add ' + thisObj.getDateString(date) + '?';
      $('.clear-reminder-btn').data('oid', oid);
      $('.clear-reminder-btn').data('model', model);
      $('.clear-reminder-btn').data('date', 'all');
    } else {
      var dateString = (date && date != 'all') ? thisObj.getDateString(date) : 'all dates for this event';
      $('.clear-reminder-btn').data('oid', oid);
      $('.clear-reminder-btn').data('model', model);
      $('.clear-reminder-btn').data('date', date);
    }
    var objectName = ($(el).data('objectName')) ? $(el).data('objectName') : $('input[name=object_name]', thisObj.reminderSheet).val();
    var objectDateString = ($(el).data('dateString')) ? $(el).data('dateString') : $('input[name=date_string]', thisObj.reminderSheet).val();
    var dateCount = ($(el).data('dateCount')) ? $(el).data('dateCount') : $('input[name=date_count]', thisObj.reminderSheet).val();
    var singleDate = (singleDate) ? singleDate : (dateCount == 1) ? true : false;
    thisObj.reminderOffcanvas.show();
    $('.hide-clear-reminder-btn', thisObj.reminderSheet).off('click').on('click', function() {
      thisObj.toggleSheetAfterClear(singleDate, el);
    });
    thisObj.overlayOff(thisObj.reminderSheet);
    $('.alert').hide();
    $('.object-name', thisObj.reminderSheet).html(objectName);
    $('.selected-date-string', thisObj.reminderSheet).html(dateString);
    if(objectDateString && !$('.date-string', thisObj.reminderSheet).html()) {
      $('.date-string', thisObj.reminderSheet).html(objectDateString);
    }
    $('.offcanvas-title .add-title', thisObj.reminderSheet).hide();
    $('.offcanvas-title .clear-title', thisObj.reminderSheet).show();
    $('.clear-body', thisObj.reminderSheet).show();
    $('.add-body', thisObj.reminderSheet).hide();
    $('.clear-reminder-btn', thisObj.reminderSheet).off('click').on('click', callback);
    return false;
  },
  allDateToggle: function(el, callback, selectedDate) {
    var thisObj = this;
    var oid = ($(el).data('oid')) ? $(el).data('oid') : $('input[name=oid]', thisObj.reminderSheet).val();
    var model = $('input[name=model]', thisObj.reminderSheet).val();
    thisObj.removeReminder(thisObj.reminderIds['all'], el, true);
    thisObj.createReminder(oid, 'attractions.occurrence', selectedDate);
    thisObj.allDateReminders.splice( $.inArray(oid, thisObj.allDateReminders), 1 );
    thisObj.toggleSheetAfterClear(selectedDate);
    thisObj.reminderOffcanvas.hide();
  },
  createAllDateReminder: function(el) {
    var thisObj = this;
    if ($(el).hasClass('reminded')) {
      var reminderId = $(el).data('itemId');
      var singleDate; // TODO: set single date from date count
      thisObj.confirmReminderClear(el, function() {
        thisObj.removeReminder(reminderId, el);
        thisObj.toggleSheetAfterClear(singleDate, el);
      });
    } else {
      var oid = $('input[name=oid]', thisObj.reminderSheet).val();
      var model = $('input[name=model]', thisObj.reminderSheet).val();
      thisObj.createReminder(oid, model, 'all');
      thisObj.reminderCalendar.dates.setFromInput(null);
    }
    return false;
  },
  getObjectReminders: function(model, oid, suppressToast) {
    var thisObj = this;
    if (model && oid) {
      var oids = (typeof (oid) == 'string') ? oid.split(',') : (typeof (oid) == 'number') ? [oid] : oid;
      var oidParams = '';
      for (let i = 0; i < oids.length; i++) {
        oidParams += `&oid=${oids[i]}`;
      }
      var remindedEvents = {};
      fetch('/api/reminders/?model=' + model + oidParams, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': Cookies.get('csrftoken')
        },
        credentials: 'same-origin'
      }).then(response => {
        if (!response.ok) {
          throw new Error('There was a problem getting your reminders.');
        }
        return response.json();
      }).then(data => {
        for (let i = 0; i < data.results.length; i++) {
          let oid = data.results[i].oid;
          let eventDate = (data.results[i].all_dates) ? 'all' : data.results[i].event_date;
          remindedEvents[oid] ??= { 'dates': [], 'reminders': [], 'cancelled_dates': []};
          remindedEvents[oid].dates.push(eventDate);
          remindedEvents[oid].event_date = data.results[i].event_date;
          remindedEvents[oid].reminders.push(data.results[i].id);
          if (data.results[i].cancelled) {
            remindedEvents[oid].cancelled_dates.push(eventDate);
          }
          if(data.results[i].all_dates) {
            thisObj.reminderIds['all'] = data.results[i].id;
            let button = $(`.reminder-btn[data-oid="${oid}"][data-model="${model}"]:not([data-date])`).not('.reminded');
            thisObj.allDateReminders.push(oid);
            thisObj.toggleReminder('remind', button, data.results[i].id, suppressToast, false);
          } else {
            let button = $(`.reminder-btn[data-oid="${oid}"][data-model="${model}"][data-date="${eventDate}"]`);
            if (button) {
              var dontCount = (i < data.results.length - 1) ? true : false;
              thisObj.toggleReminder('remind', button, data.results[i].id, suppressToast, dontCount);
            }
          }
        }
        var remindedEventIds = Object.keys(remindedEvents);
        for (let i = 0; i < remindedEventIds.length; i++) {
          var eventId = remindedEventIds[i];
          thisObj.updateReminderCardDate(eventId, remindedEvents[eventId].dates, remindedEvents[eventId].cancelled_dates, remindedEvents[eventId].event_date);

          let noDateButton = $(`.reminder-btn[data-oid="${eventId}"][data-model="${model}"]:not([data-date])`).not('.reminded');
          noDateButton.each(function() {
            $(this).addClass('reminded');
            if($(this).hasClass('btn')) {
              $(this).addClass('btn-primary').removeClass('btn-light');
            }
            $(this).find('.reminder-btn-bell').removeClass('fa-swap-opacity');
            $('.reminder-set-message', this).show();
            $('.no-reminder-message', this).hide();
          });
        }
      }).catch(error => {
        console.log(error.message);
      });
    }
  },
  populateReminderSheet: function(oid, model, objectName, dateString, date, dateCount) {
    var thisObj = this;
    if (!window.idx.userAuthenticated) {
      showLoginSheet();
    } else {
      $('input[name=model]', thisObj.reminderSheet).val(model);
      $('input[name=oid]', thisObj.reminderSheet).val(oid);
      $('input[name=object_name]', thisObj.reminderSheet).val(objectName);
      $('input[name=date]', thisObj.reminderSheet).val(date);
      $('input[name=date_count]', thisObj.reminderSheet).val(dateCount);
      if (objectName) {
        $('.object-name', thisObj.reminderSheet).html(objectName);
        $('.date-string', thisObj.reminderSheet).html(dateString);
      }
      thisObj.overlayOn(thisObj.reminderSheet);
      thisObj.getReminderDatesForSheet(oid, objectName, date);
    }
  },
  getReminderDatesForSheet: function(oid, objectName, selectedDate) {
    var thisObj = this;
    thisObj.clearSheetError(thisObj.reminderSheet);
    if(!thisObj.reminderCalendar) {
      var options = {
        display: {
          inline: true,
          theme: 'light',
          viewMode: 'calendar',
          components: {
            decades: false,
            year: false,
            month: true,
            date: true,
            hours: false,
            minutes: false,
            seconds: false
          }
        },
        localization: {
          dayViewHeaderFormat: { month: "long", year: "numeric" }
        },
        multipleDates: true,
        useCurrent: false
      }
      thisObj.reminderCalendar = new tempusDominus.TempusDominus(document.getElementById('reminderCalendar'), options);
    }
    thisObj.reminderIds = {};
    thisObj.reminderDates = [];
    fetch('/api/reminders/occurrence_dates/?page_size=200&occurrence=' + oid, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRFToken': Cookies.get('csrftoken')
      },
      credentials: 'same-origin'
    }).then(response => {
      if (!response.ok) {
        throw new Error('There was a problem getting your reminders.');
      }
      return response.json();
    }).then(data => {
      if (data.meta && data.meta.auth == false) {
        showLoginSheet();
      } else {
        if (!data.count) {
          thisObj.showSheetError(thisObj.reminderSheet, 'There were no upcoming dates found for this event.');
        } else {
          // populate sheet
          thisObj.reminderDates = [];
          thisObj.reminderIds = {};
          let userHasReminders = data.user_data.has_reminders;
          let dates = [];
          let reminderCount = 0;
          let dateString;
          let allDatesReminder = data.all_dates_reminder;
          if (!objectName) {
            objectName = data.event.name;
            $('.object-name', thisObj.reminderSheet).html(objectName);
            $('input[name=object_name', thisObj.reminderSheet).val(objectName);
          }
          if (!dateString) {
            dateString = data.event.date_string;
            $('.date-string', thisObj.reminderSheet).html(dateString);
            $('input[name=date_string', thisObj.reminderSheet).val(dateString);
          }
          for (let i = 0; i < data.results.length; i++) {
            const sd = data.results[i];
            let reminder = sd.reminder;
            let tdDate = new tempusDominus.DateTime(sd.iso_date);
            if (reminder && 'id' in reminder) {
              let dateString = (reminder['id'] == allDatesReminder) ? 'all' : sd.date;
              thisObj.reminderDates.push(tdDate);
              thisObj.reminderIds[dateString] = reminder['id'];
              reminderCount++;
            }
            dates.push(tdDate);
          }
          if (allDatesReminder) {
            thisObj.reminderIds['all'] = allDatesReminder;
            thisObj.allDateReminders.push(oid);
            reminderCount = 1;
          }

          if (data.count == 1) {
            // single date event
            if (!selectedDate) {
              selectedDate = data.results[0].date;
              $('input[name=date_count]', thisObj.reminderSheet).val('1');
            }
          } else {
            // multi date event
            var allDatesBtn = $('a[data-date="all"]', thisObj.reminderSheet);
            var allDatesTab = document.querySelector('a[data-bs-target="#calendarAll"]');
            var chooseDateTab = document.querySelector('a[data-bs-target="#calendarChooseDates"]');
            if(allDatesReminder) {
              allDatesBtn.data('itemId', allDatesReminder);
              $('#calendarAll .reminder-set-message').show();
              $('#calendarAll .no-reminder-message').hide();
              bootstrap.Tab.getOrCreateInstance(allDatesTab).show();
            } else {
              allDatesBtn.data('itemId', '');
              $('.reminder-count-message').show();
              $('#calendarAll .reminder-set-message').hide();
              $('#calendarAll .no-reminder-message').show();
              bootstrap.Tab.getOrCreateInstance(chooseDateTab).show();
              for (let i = 0; i < thisObj.reminderDates.length; i++) {
                thisObj.reminderCalendar.dates.setValue(thisObj.reminderDates[i], thisObj.reminderCalendar.dates._dates.length);
              }
            }
          }
          if (selectedDate && Object.keys(thisObj.reminderIds).indexOf(selectedDate) == -1 && !allDatesReminder) {
            thisObj.createReminder(oid, 'attractions.occurrence', selectedDate);
            var parsedDate = thisObj.reminderCalendar.dates.parseInput(selectedDate + 'T00:00:00');
            thisObj.reminderCalendar.dates.setValue(parsedDate, thisObj.reminderCalendar.dates._dates.length);
            let selectedDateString = thisObj.getDateString(selectedDate);
            let selectedDateText = '<strong>👍 Okay!</strong><br>';
            selectedDateText +=
              (data.count == 1
                ? `We'll remind you about this event.`
                : `We'll remind you about the <strong>${selectedDateString}</strong> event.<br>You can select additional dates below.`);
            $('.selected-date-alert', thisObj.reminderSheet).show();
            $('.selected-date-alert', thisObj.reminderSheet).html(selectedDateText);
          } else {
            $('.selected-date-alert', thisObj.reminderSheet).hide();
            $('.selected-date-alert', thisObj.reminderSheet).html('');
          }
          $('.reminder-dates', thisObj.reminderSheet).html('');
          var setReminders = Object.entries(thisObj.reminderIds);
          if (allDatesReminder) {
            thisObj.createRemoveReminderRow('all', allDatesReminder);
          } else if(setReminders.length > 0) {
            setReminders.sort(function(a, b) { return new Date(a[0]) - new Date(b[0]); });
            for (let i = 0; i < setReminders.length; i++) {
              var reminder = setReminders[i][1];
              var date = (reminder == allDatesReminder) ? 'all' : setReminders[i][0];
              thisObj.createRemoveReminderRow(date, reminder);
            }
          }
          if(reminderCount > 0) {
            if(reminderCount == 1) {
              $('.reminder-plural').hide();
              $('.reminder-count-message .reminder-count').html('');
              $('.reminder-count-message .reminder-count', thisObj.reminderSheet).html(reminderCount);
            } else {
              $('.reminder-plural').show();
              $('.reminder-count-message .reminder-count').html(reminderCount);
            }
            $('.reminder-count-message').show();
            $('.reminder-body .default-message').hide();
          } else {
            $('.reminder-count-message').hide();
            $('.reminder-body .default-message').show();
          }
          if (data.count > 1) {
            thisObj.reminderCalendar.updateOptions({
              restrictions: {
                enabledDates: dates,
                minDate: dates[0],
                maxDate: dates[-1]
              },
              viewDate: dates[0]
            });
            document.getElementById('reminderCalendar').addEventListener('change.td', thisObj.calendarOnChange);
            $('.reminder-calendar').show();
            $(".reminder-calendar-column").show();
          } else {
            $('.reminder-calendar-column').hide();
          }
        }
      }
      thisObj.overlayOff(thisObj.reminderSheet);
    }).catch(error => {
      console.log(error.message);
      thisObj.showSheetError(thisObj.reminderSheet);
    });
  },
  createRemoveReminderRow: function(date, reminder) {
    var thisObj = this;
    var dateBlock = '';
    var dateStr = thisObj.getDateString(date);
    if (date == 'all') {
      dateBlock += `<div class="mb-1 text-black remove-reminder-row">${dateStr} <a class="text-danger remove-reminder-btn" data-date="${date}" data-item-id="${reminder}"><i class="fal fa-trash-alt"></i></a></div>`;
      $('.reminder-dates', thisObj.reminderSheet).html('');
      $('.reminder-dates', thisObj.reminderSheet).append(dateBlock);
    } else {
      $('.remove-reminder-row a[data-date="all"]', thisObj.reminderSheet).parents('.remove-reminder-row').hide();
      dateBlock += `<div class="mb-1 text-black remove-reminder-row">${dateStr} <a class="text-danger remove-reminder-btn" data-date="${date}" data-item-id="${reminder}"><i class="fal fa-trash-alt"></i></a></div>`;

      let dates = $('.remove-reminder-btn', thisObj.reminderSheet).map(function() { return $(this).data('date'); }).get();
      let dateIndex = dates.findIndex(d => (new Date(d) > new Date(date)));
      if (dates.length > 0 && dateIndex >= 0) {
        $('.remove-reminder-row', thisObj.reminderSheet).eq(dateIndex).before(dateBlock);
      } else {
        $('.reminder-dates', thisObj.reminderSheet).append(dateBlock);
      }
    }
  },
  updateReminderCardDate: function(eventId, dates, cancelledDates, nextDate) {
    if(eventId) {
      if (dates.length > 0) {
        var thisObj = this;
        var dateString;
        if (dates.includes('all')) {
          dateString = (nextDate) ? thisObj.getDateString(nextDate) + ' <small class="fs-6 fw-normal">and more dates</small>' : thisObj.getDateString('all');
        } else {
          dates.sort(function(a, b) { return new Date(a) - new Date(b); });
          dateString = thisObj.getDateString(dates[0]);
          if(dates.length > 1) {
            var plural = (dates.length > 2) ? 's' : '';
            dateString += ` <small class="fs-6 fw-normal">and ${dates.length - 1} more date${plural}</small>`;
          }
        }
        var cancelledDateString = (cancelledDates.includes(dates[0])) ? ' <small class="fs-6 fw-bold text-danger d-block">CANCELED</small>' : '';
        var dateMarkup = `<div class="p-2 mb-0 text-center fw-bold">${cancelledDateString} ${dateString}</div>`;
        $(`.reminder-dates[data-oid=${eventId}]`).html(dateMarkup);
      } else {
        $(`.reminder-dates[data-oid=${eventId}]`).html('');
      }
    }
  },
  setupButtons: function(populate, suppressToast) {
    var thisObj = this;
    if(populate) {
      var reminderData = {};
      $('.reminder-btn').each(function () {
        let model = $(this).data('model');
        let oid = $(this).data('oid');
        if (model && oid) {
          if (model in reminderData) {
            if(!reminderData[model].includes(oid)) {
              reminderData[model].push(oid);
            }
          } else {
            reminderData[model] = [oid];
          }
        }
      });
      for (let i = 0; i < Object.keys(reminderData).length; i++) {
        let key = Object.keys(reminderData)[i];
        thisObj.getObjectReminders(key, reminderData[key], suppressToast);
      }
    }

    $('.reminder-btn').off('click').on('click', function(e) {
      if (!window.idx.userAuthenticated) {
        showLoginSheet();
      } else {
        const button = this;
        const model = $(this).data('model');
        const oid = $(this).data('oid');
        const date = $(this).data('date');
        const dateCount = $(this).data('dateCount');
        const singleDate = (dateCount == 1) ? true : false;
        const objectName = $(this).data('objectName');
        const reminderId = $(this).data('itemId');
        const dateString = $(this).data('dateString');

        if ($(this).hasClass('reminded') && dateCount == 1 && !thisObj.allDateReminders.includes(oid)) {
          thisObj.confirmReminderClear(this, function() {
            thisObj.removeReminder(reminderId, button);
            thisObj.toggleSheetAfterClear(singleDate, button);
            thisObj.reminderOffcanvas.hide();
          }, true);
        } else {
          if($(this).data('date') && $(this).data('date') != 'all' && thisObj.allDateReminders.includes(oid)) {
            thisObj.confirmReminderClear(this, function() {
              thisObj.allDateToggle(this, null, date);
            }, false, true);
          } else {
            thisObj.populateReminderSheet(oid, model, objectName, dateString, date, dateCount);
          }
        }
      }
      e.preventDefault();
    });

    $(thisObj.reminderSheet).off('click', '.reminder-btn-all').on('click', '.reminder-btn-all', function() {
      var date = $(this).data('date');
      if (date == 'all') {
        if ($(this).data('itemId')) {
          thisObj.confirmReminderClear(this, thisObj.clearAllReminders);
        } else {
          thisObj.createAllDateReminder(this);
        }
      }
      return false;
    });
    $(thisObj.reminderSheet).off('click', '.reminder-btn-clear').on('click', '.reminder-btn-clear', function() {
      var date = $(this).data('date');
      if (date == 'all') {
        thisObj.confirmReminderClear(this, thisObj.clearAllReminders);
      }
      return false;
    });

    $('body').on('click', '.remove-reminder-btn', function(e) {
      if (!window.idx.userAuthenticated) {
        showLoginSheet();
      } else {
        const reminderId = $(this).data('itemId');
        const date = $(this).data('date');
        const dateCount = ($(this).data('dateCount')) ? $(this).data('dateCount') : $('input[name=date_count]').val();
        const singleDate = (dateCount == 1) ? true : false;
        var button = this;
        if (date == 'all') {
          thisObj.confirmReminderClear(this, thisObj.clearAllReminders);
        } else {
          thisObj.confirmReminderClear(button, function() {
            thisObj.removeReminder(reminderId, e);
            thisObj.toggleSheetAfterClear(singleDate, button);
          });
        }
      }
      e.preventDefault();
    });
    $('body').on('click', '.hide-clear-reminder-btn', function() {
      $('.add-body', thisObj.reminderSheet).show();
      $('.clear-body', thisObj.reminderSheet).hide();
      $('.add-title', thisObj.reminderSheet).show();
      $('.clear-title', thisObj.reminderSheet).hide();
    });
  },
  init: function() {
    var thisObj = this;
    thisObj.reminderSheet = document.getElementById('reminderSheet');
    thisObj.reminderOffcanvas = new bootstrap.Offcanvas(document.getElementById('reminderSheet'));
    if (thisObj.reminderSheet) {
      thisObj.reminderSheet.addEventListener('hidden.bs.offcanvas', function () {
        // on close sheet
        document.getElementById('reminderCalendar').removeEventListener('change.td', thisObj.calendarOnChange);

        var chooseDateTab = document.querySelector('a[data-bs-target="#calendarChooseDates"]');
        bootstrap.Tab.getOrCreateInstance(chooseDateTab).show();
        if(thisObj.reminderCalendar) {
          thisObj.reminderCalendar.dispose();
          thisObj.reminderCalendar = null;
        }
        $(".reminder-body .default-message").hide();
        $('.reminder-calendar', thisObj.reminderSheet).hide();
        $('.add-title', thisObj.reminderSheet).show();
        $('.clear-title', thisObj.reminderSheet).hide();
        $('.add-body', thisObj.reminderSheet).show();
        $('.clear-body', thisObj.reminderSheet).hide();
        $('.loading-spinner', thisObj.reminderSheet).show();
        $('.display-item', thisObj.reminderSheet).hide();

      });
    }
    thisObj.setupButtons(true, true);
  }
}
window.Reminders = Reminders;

$(function() {
  Reminders.init();
})
